import {
  addFloatingButton,
  addNavMenuItem,
  DataService,
  ModalService,
  NotificationService,
  PageLocationId,
  registerPageTab,
} from "@bb-vendure/admin-ui/core";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import CreateTicketRequest from "./components/Create/create.dialog";
import { take } from "rxjs";
import { CreateTicketDocument } from "src/generated-gql/graphql";
import { InternalReqByMeComponent } from "./components/internal/req-by-me/req-by-me.component";
import { InternalAsgToMeComponent } from "./components/internal/assign-to-me/assign-to-me.component";

export default [
  addNavMenuItem(
    {
      id: "ticket",
      label: "ticket.tickets",
      routerLink: ["/extensions/tickets"],
    },
    "ticket-section"
  ),
  addNavMenuItem(
    {
      id: "ticket-bulletin",
      label: "ticket.qa-bulletin-board",
      routerLink: ["/extensions/tickets-bulletin"],
    },
    "ticket-section"
  ),

  addFloatingButton({
    onClick(injector) {
      const modalService = injector.get(ModalService);
      const dataService = injector.get(DataService);
      const notiService = injector.get(NotificationService);
      modalService
        .fromComponent(CreateTicketRequest, {
          closable: true,
          size: "xl",
          locals: {
            isFromFloating: true,
            isInternal: false,
          },
        })
        .pipe(take(1))
        .subscribe((input) => {
          if (input) {
            dataService
              .mutate(CreateTicketDocument, {
                input,
              })
              .pipe(take(1))
              .subscribe((result) => {
                if (result.createTicket) {
                  notiService.success("ticket.create-success");
                }
              });
          }
        });
    },
    icon: "plus",
    iconSize: 30,
  }),

  registerPageTab({
    location: "ticket-list" as PageLocationId,
    tab: "ticket.assign-to-me",
    route: "/extensions/tickets",
    component: InternalAsgToMeComponent,
  }),
  registerPageTab({
    location: "ticket-list" as PageLocationId,
    tab: "ticket.requested-by-me",
    route: "/extensions/tickets/me",
    component: InternalReqByMeComponent,
  }),
];
